import { ReactNode, useContext, useMemo, useState } from 'react';
import {
  ConfigurationContext,
  ConfigurationContextValue,
  SelectedWorkflow,
} from 'src/context/ConfigurationContext';

export function useConfigurationContext(): ConfigurationContextValue | null {
  return useContext(ConfigurationContext);
}

export function ConfigurationProvider({ children }: Readonly<{ children: ReactNode }>) {
  const [isEditWorkflowMode, setIsEditWorkflowMode] = useState(false);
  const [selectedWorkflow, setSelectedWorkflow] = useState<SelectedWorkflow | null>(null);

  const value = useMemo(
    () => ({ isEditWorkflowMode, setIsEditWorkflowMode, selectedWorkflow, setSelectedWorkflow }),
    [isEditWorkflowMode, selectedWorkflow],
  );

  return <ConfigurationContext.Provider value={value}>{children}</ConfigurationContext.Provider>;
}
